export default async function updateCondominio(updates) {
    try {
        // Obtém os dados do sessionStorage
        const userSession = JSON.parse(sessionStorage.getItem("user"));

        if (!userSession || !userSession.token || !userSession.condominio) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { token, condominio } = userSession;

        console.log("Atualizando condomínio:", { condominio, updates });

        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/condominio/${encodeURIComponent(condominio)}`, {
            method: "PUT", // Método HTTP para atualizar
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(updates), // Dados a serem atualizados
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Erro ao atualizar condomínio: ${errorData.error || response.statusText}`);
        }

        const data = await response.json();

        if (!data) {
            throw new Error("Resposta inválida da API.");
        }

        console.log("Condomínio atualizado com sucesso:", data);
        return data; // Retorna o resultado da API
    } catch (error) {
        console.error("Erro ao atualizar condomínio:", error.message);
        throw error; // Propaga o erro para tratamento externo
    }
}
